module.exports = __webpack_public_path__ + "img/w67b.07cc2787.jpg";